import LogRocket from "logrocket";

export const MAX_RECORDING_MS = 15 * 60 * 1000;
export const WARNING_THRESHOLD_MS = 13 * 60 * 1000;

const getAppId = () => process.env.REACT_APP_LOGROCKET_APP_ID ?? "";

const isAlreadyInitialized = () => {
  const appId = getAppId();
  return Boolean(LogRocket.sessionURL && appId && LogRocket.sessionURL.includes(appId));
};

const buildInitOptions = () =>
  process.env.REACT_APP_LOGROCKET_INTEGRATION_DESANITIZATION === "true"
    ? {}
    : {
        dom: { inputSanitizer: true, textSanitizer: true },
        network: { isEnabled: false },
      };

// Manual-recording entry point: always inits if not already initialized.
// No sampling and no env-gate beyond the app id — the button must always work.
export const ensureRecordingReady = (): boolean => {
  const appId = getAppId();
  if (!appId) {
    return false;
  }
  if (isAlreadyInitialized()) {
    return true;
  }
  LogRocket.init(appId, buildInitOptions());
  return true;
};

export const getSessionURL = (): string | null => {
  const appId = getAppId();
  const url = LogRocket.sessionURL;
  if (!url || !appId || !url.includes(appId)) {
    return null;
  }
  return url;
};

export const startNewRecordingSession = () => {
  LogRocket.startNewSession();
};
